import { useHandleSignInCallback } from '@logto/react';
import { useNavigate } from '@tanstack/react-router';
import { Button } from '@/components/ui';
import { useAuth } from '@/lib/auth';
import { takeReturnPath } from '@/lib/auth/return-to';

export const CallbackPage = () => {
  const navigate = useNavigate();
  const { signIn } = useAuth();

  const { isLoading, error } = useHandleSignInCallback(() => {
    const returnTo = takeReturnPath();
    if (returnTo) {
      navigate({ to: returnTo as never, replace: true });
    } else {
      navigate({ to: '/', replace: true });
    }
  });

  if (error) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="w-full max-w-sm px-6 text-center">
          <h1 className="mb-2 text-lg font-medium text-foreground">Sign-in failed</h1>
          <p className="text-sm text-muted-foreground">Unable to complete sign-in. Please try again.</p>
          <Button className="mt-6" type="button" variant="outline" onClick={() => void signIn()}>
            Sign in again
          </Button>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-sm text-muted-foreground">Completing sign-in...</p>
      </div>
    );
  }

  return null;
};
